import { apiClientJoin } from "@/api/join_api";
import { apiClient, apiClientFormUpload } from "@/api/softphone_api.js";
// import { apiClientPbx } from "@/api/sipmovil_auth_api.js"

export const getDirectory = async ({ commit }, { page, size, characters }) => {
  // const res = await apiClientPbx.get(`api/webrtc/get_directory_paginated?page_size=${size}&page=${page}&characters=${characters}`);
  try {
    let url = `api/webrtc/get_directory_paginated?page_size=${size}&page=${page}`;
    if (characters !== undefined && characters !== "") {
      url += `&characters=${characters}`;
    } else {
      commit("setLoading", true);
    }
    const res = await apiClient.get(url);
    // console.log("response Directory Paginated: ", res.data.results);
    commit("loadDirectory", {
      results: res.data.results,
      count: res.data.count,
    });
  } catch (error) {
    console.log(error);
  } finally {
    commit("setLoading", false); // Set loading as false after receiving the response from the API
  }
};

export const getPersonalContacts = async ({ commit }) => {
  const res = await apiClient.get(`api/webrtc/personal_contacts`);
  console.log("Personal contacts: ", res.data);
  commit("loadPersonalContacts", res.data);
};

export const getRecords = async ({ commit }) => {
  const res = await apiClient.get(`api/webrtc/records_app`);
  const parseData = {
    dicc: {
      records: res.data.dicc.records,
    },
    num_pages: res.data.num_pages,
    page_size: res.data.page_size,
    total: res.data.total,
  };
  console.log("RESPONSE RECORDS API: ", res.data.dicc.records);
  commit("loadRecords", parseData);
};

export const getRecordsFilters = async ({ commit }, { filters }) => {
  const {
    init_datetime,
    finish_datetime,
    numbers,
    calls_ids,
    page_size,
    page_number,
    kind,
    contact,
  } = filters;

  const data = {
    init_datetime,
    finish_datetime,
    numbers,
    calls_ids,
    page_size,
    page_number,
    kind,
    contact,
  };

  // if (numbers.length > 0) {
  //   data.numbers = numbers
  // }

  // if (calls_ids.length > 0) {
  //   console.log('si tengo algo');
  //   console.log(calls_ids.length);
  //   data.calls_ids = calls_ids
  // }

  const res = await apiClient.post(`api/webrtc/records_app`, data);
  const parseData = {
    message: res.data.message,
    dicc: {
      records: res.data.records,
    },
    num_pages: res.data.num_pages,
    page_size: res.data.page_size,
    total: res.data.total,
  };
  // console.log("RESPONSE RECORDS API: ", res.data.dicc.records);
  commit("loadRecords", parseData);
};

export const getCallRecords = async ({ commit }, { dataToFilter }) => {
  // const res = await apiClient.get(`api/webrtc/calls_app`);
  try {
    commit("setLoading", true);
    const res = await apiClient.post(`api/webrtc/get_calls/`, dataToFilter);
    // commit("loadRecords", res.data.cdrs);
    commit("loadCallRecords", res.data);
    return res;
  } catch (error) {
    console.log(error);
  } finally {
    commit("setLoading", false);
  }
};
export const getNextPage = async ({ commit }, { page, q, size }) => {
  const res = await apiClient.get(
    `/api/webrtc/personal_contacts?page=${page}&q=${q}&size=${size}`
  );
  console.log("Next page res", res.data);
  commit("loadPersonalContacts", res.data);
};

export const getVoiceMail = async ({ commit }, { page = 1, pageSize = 50 } = {}) => {
  const res = await apiClient.get(`api/webrtc/list_voicemail_app?page=${page}&page_size=${pageSize}`);
  commit("loadVoiceMail", res.data);
};

export const getConferences = async ({ commit }) => {
  const res = await apiClient.get(`api/webrtc/conferences_app`);
  const conferences = res.data.dicc;
  console.log("Conferences", res.data.dicc);
  commit("loadConferences", conferences);
};

export const getConferencesPage = async ({ commit }, { page }) => {
  const postData = new FormData();
  postData.append("page_number", page);
  const res = await apiClient.post(`api/webrtc/conferences_app`, postData);
  const conferences = res.data;
  console.log("Nex page Conferences", res.data);
  commit("loadConferences", conferences);
};

export const getVoiceMailCount = async ({ commit }) => {
  const res = await apiClient.get("api/webrtc/get_voicemail_count");
  const count = Number(res.data);
  console.log(count);
  commit("loadVoiceMailCount", count);
};

export const getUserSettings = async ({ commit }) => {
  console.log("getUserSettings action executed");
  const res = await apiClient.get(`api/webrtc/update_settings_rest`);
  console.log("Res getUserSettings", res.data);
  commit("loadUserSettingsRecords", res.data);
};

export const getMeetings = async (
  { commit },
  { page, mutation1, mutation2, entity, itemsPerPage, search, date_from, date_to }
) => {
  if (page > 0 && entity !== "meeting_list") {
    page = page - 1;
  }
  // const res = await apiClientPbx.get(`api/webrtc/get_directory_paginated?page_size=${size}&page=${page}&characters=${characters}`);
  try {
    let url = `api/webrtc/${entity}/`;
    const offset = (page - 1) * itemsPerPage;
    const filters = {
      params: {
        offset,
        limit: itemsPerPage,
        search: search,
        ...(date_from ? { date_from } : {}),
        ...(date_to ? { date_to } : {}),
      },
    };
    let res;
    if (entity !== "meeting_list") {
      res = await apiClient.get(url);
    } else {
      res = await apiClient.get(url, filters);
    }
    commit(mutation1, res.data.results);
    commit(mutation2, res.data.count);
    // commit("loadMeetingsList", { results: res.data.results, count: res.data.count });
  } catch (error) {
    console.log(error);
  } finally {
    commit("setLoading", false); // Set loading as false after receiving the response from the API
  }
};

export const downloadMeetingsExcel = async (
  _,
  { entity, search, date_from, date_to }
) => {
  const url = `api/webrtc/${entity}/download_excel/`;
  const params = {
    search: search,
    ...(date_from ? { date_from } : {}),
    ...(date_to ? { date_to } : {}),
  };
  const res = await apiClient.get(url, { responseType: "blob", params });
  return res;
};

export const createMeeting = async ({ commit }, { meeting_name }) => {
  const url = `api/webrtc/url_meet_app?name_room=${meeting_name}`;
  try {
    const res = await apiClient.post(url);
    // console.log('Response from createMeeting:', res.data);
    // console.log('Response from createMeeting:', res.data.url);
    //***** Set meeting link in the store ******/
    commit("setNewMeetings", res.data.url);

    window.open(res.data.url, "_blank");
  } catch (error) {
    console.error("Error creating meeting:", error);
    throw error; // Propagar el error para que el componente lo capture
  }
};
export const downloadVideoMeeting = async (
  { commit },
  { name_room, room_id }
) => {
  const url = `api/webrtc/download-meeting/?name_room=${name_room}&room_id=${room_id}`;
  try {
    const res = await apiClient.get(url);
    // console.log('Response from createMeeting:', res.data);
    // console.log('Response from createMeeting:', res.data.url);
    //***** Set meeting link in the store ******/
    console.log("Error creating meeting:", res.data.path_video);
    console.log("Error creating meeting:", res.data.file_exist);
    commit("setVideoMeeting", res);
    return res;
    //window.open(res.data.url, '_blank');
  } catch (error) {
    console.error("Error creating meeting:", error);
    throw error; // Propagar el error para que el componente lo capture
  }
};
export const downloadTranscriptionMeeting = async (
  { rootState },
  { room_id }
) => {
  console.log('downloadTranscriptionMeeting action llamada');
  console.log('room_id recibido:', room_id);
  
  const url = `api/webrtc/download_transcription/?room_id=${room_id}`;
  console.log('URL completa:', url);
  
  try {
    const res = await apiClient.get(url);
    
    //console.log('Respuesta recibida:', res.data);
    
    if (res.data.files && res.data.files.length > 0) {
      // Obtener el PbxServer del estado de auth
      const pbxServer = rootState.auth_store.userInfo.PbxServer;
      console.log('PbxServer obtenido del estado:', pbxServer);
      for (const file of res.data.files) {
        await downloadSingleFile(file, pbxServer);
      }
      
      return {
        success: true,
        message: `${res.data.transcriptions_downloaded} transcripción(es) descargada(s)`,
        data: res.data
      };
    } else {
      return {
        success: false,
        message: 'No hay transcripciones disponibles',
        data: res.data
      };
    }
  } catch (error) {
    console.error("Error downloading transcription:", error);
    throw error;
  }
};

const downloadSingleFile = async (file, pbxServer) => {
  try {
    //console.log('📂 file.path recibido:', file.path);
    //console.log('🌐 PbxServer recibido:', pbxServer);
    
    const fileUrl = `https://${pbxServer}${file.path}`;
    console.log('🔗 URL completa construida:', fileUrl);
    
    const response = await fetch(fileUrl);
    
    if (!response.ok) {
      throw new Error(`Error al descargar ${file.filename}: ${response.status} ${response.statusText}`);
    }
    
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    
    // Obtener el nombre del archivo desde el path
    const fileNameFromPath = file.path.split('/').pop();
    link.download = fileNameFromPath;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
    
    console.log(` Descargado exitosamente: ${fileNameFromPath}`);
  } catch (error) {
    console.error(`Error descargando archivo ${file.filename}:`, error);
    throw error;
  }
};
export const getDetailChatData = async ({ commit }, { isGroup, id }) => {
  const url = isGroup
    ? `api/chat/chat_data/${id}/`
    : `api/chat/chat-profile-detail/${id}/`;
  try {
    console.log("url detail chat", url);
    const res = await apiClient.get(url);
    commit("setDetailtChatData", res.data);
    commit("setShowDetailChat", true);
    console.log("res detail chat", res.data);
  } catch (error) {
    console.log("error", error);
  }
};
export const getDetailChatDataJoin = async ({ commit }, id ) => {
  try {
    const res = await apiClientJoin.get(`/whatsapp-official/sender-comment/${id}/`);
    commit("setDetailtChatDataJoin", res.data);
    commit("setShowDetailChatJoin", true);
  } catch (error) {
    console.log("error", error);
  }
};

export const getDetailChatDataFexIA = async ({ commit }, id) => {
  try {
    const url = `api/chat/chat_data_fexia/${id}/`;
    const res = await apiClient.get(url);
    commit("setDetailChatDataFexIA", res.data);
    commit("setShowDetailChatFexIA", true);
  } catch (error) {
    console.log("error", error);
  }
};

export const saveDetailChatJoin = async ({ commit }, { id, data }) => {
  console.log("saveDetailChatJoin data", data);
  try {
    const res = await apiClientJoin.patch(`/whatsapp-official/sender-comment/${id}/`, data);
    console.log("res save detail chat join", res.data);
    commit("setDetailtChatDataJoin", res.data);
  } catch (error) {
    console.log("error", error);
  }
}

export const getDataViewDrive = async ({ commit }) => {
  const link = "api/pbx/drive_list/";
  try {
    const res = await apiClient.get(link);
    console.log('data', res.data);
    commit("setDriveData", res.data);
  } catch (err) {
    console.error("r", err);
  }
};

export const getDataFolder = async ({ commit }, option) => {
  let link;
  if (option == 'CRM') {
    link = 'api/pbx/storage_crm/'
  } else if (option == 'CHATS') {
    link = 'api/pbx/storage_chats/'
  } else if (option == 'MIS GRABACIONES') {
    link = 'api/pbx/storage_records/'
  } else {
    link = 'api/pbx/'
  }
  try {
    const res = await apiClient.get(link)
    commit("setFolderData", res.data);
  } catch (err) {
    console.error("r", err);
  }
}

export const getProtectedFolder = async ({ commit }, option) => {
  const link = 'api/pbx/drive_protected_folder_details/'
  let folder = null
  if (option == 'CHATS' || option === 'chats') {
    folder = 'chats'
  } else if (option == 'MIS GRABACIONES' || option === 'records') {
    folder = 'records'
  } else if (option == 'CRM' || option === 'crm') {
    folder = 'crm'
  } else if (option == 'COMPARTIDO CONMIGO' || option == ' COMPARTIDO CONMIGO') {
    folder = 'shared'
  }
  const data = {
    params: {
      folder
    }
  }
  try {
    const res = await apiClient.get(link, data)
    console.log({res});
    const resData = res.data
    resData.folder = folder
    commit("setUserProtectedFolder", resData);
  } catch (err) {
    console.error("r", err);
  }
}

export const getFolderDrive = async ({ commit }, idFolder) => {
  const link = 'api/pbx/drive_folders/'
  try {
    const data = {
      params: {
        parent_folder: idFolder
      }
    }
    const res = await apiClient.get(link, data)
    const parsedData = {
      data: res.data,
      idFolder
    }
    commit('setFolderData2', parsedData)
  } catch (err) {
    console.error(err);
  }
}

export const getFilesFolderDrive = async ({ commit }, idFolder) => {
  const link = 'api/pbx/drive_files/'
  try {
    const data = {
      params: {
        folder: idFolder ? idFolder : null
      }
    }
    const res = await apiClient.get(link, data)
    commit('setFilesFolder', res.data)
  } catch (err) {
    console.error(err);
  }
}

export const uploadFilesDrive = async (_, {files, folder}) => {
  const link = 'api/pbx/drive_upload/'
  const formData = new FormData();
  try {
    for (const file of files) {
      formData.append('file', file)
    }
    if (folder && folder !== 'protected') formData.append('folder', folder);
    // tiempo de espera maxima 5 minutos
    const res = await apiClientFormUpload.post(link, formData, {timeout: 300000})
    if (res) {
      console.log({res});
      
      console.log('pass');
    }
  } catch (err) {
    console.error(err);
  }
}

export const downloadFile = async (_, url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const blob = await response.blob();
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `SipMóvil_Chat_${url.split('/').at(-1)}`;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};
export const updateCallRecord = async ({ commit }, params) => {
  console.log("DATA PUT: ", params.data);
  const url = `/api/${params.url}/`;
  const res = await apiClient.patch(url, params.data);
  console.log(`RESPONSE PUT ENTY TO ${url}`, res);
  commit(params.mutation1, {
    key: params.enty,
    keySearch: params.keySearch,
    value: res.data,
  });

  return res;
};


export const getUserStorage = async ({commit}) => {
  const link = 'api/pbx/user_storage/'
  try {
    const res = await apiClient.get(link)
    commit('setUserStorage', res.data)
  } catch (err) {
    console.error(err);
  }
}

export const getFolder = async ({commit}, idFolder) => {
  console.log({idFolder});
  const link = 'api/pbx/drive_folder'
  const data = {
    params: {
      folder: idFolder
    }
  }
  try {
    const res = await apiClient.get(link, data)
    commit('setFolder', res.data)
  } catch (err) {
    console.error(err);
  }
}

export const downloadFilesAndFolders = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_download_files_folders/', data, {
      responseType: 'blob'
    })
    
    if (!res.status === 200) {
      throw new Error(`Error al descargar los archivos: ${res.statusText}`);
    }

    // Create a URL for the file blob and trigger download
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;

    const fileName = res.headers.get("filename") ? res.headers.get("filename") || 'download.zip' : 'drive.zip'

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error downloading files and folders:', error);

    // Verifica si error.response y error.response.data están disponibles
    const errorMessage = error.response && error.response.data && error.response.data.detail 
        ? error.response.data.detail 
        : 'An error occurred while downloading files.';
    
    alert(errorMessage);
  }
}

export const copyFilesAndFolders = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_copy/', data)
    console.log(res.data);
  } catch (err) {
    console.log(err);
  }
}

export const cutFilesAndFolders = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_cut/', data)
    console.log(res.data);
  } catch (err) {
    console.log(err);
  }
}

export const copyProtectedFiles = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_copy_protected/', data)
    console.log(res.data);
  } catch (err) {
    console.log(err);
  }
}

export const cutProtectedFiles = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_cut_protected/', data)
    console.log(res.data);
  } catch (err) {
    console.log(err);
  }
}

export const downloadProtectedFiles = async (_, data) => {
  try {
    const res = await apiClient.post('api/pbx/drive_download_protected/', data, {
      responseType: 'blob'
    })
    
    if (!res.status === 200) {
      throw new Error(`Error al descargar los archivos: ${res.statusText}`);
    }

    // Create a URL for the file blob and trigger download
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;

    const fileName = res.headers.get("filename") ? res.headers.get("filename") || 'download.zip' : 'drive.zip'

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error downloading files and folders:', error);

    // Verifica si error.response y error.response.data están disponibles
    const errorMessage = error.response && error.response.data && error.response.data.detail 
        ? error.response.data.detail 
        : 'An error occurred while downloading files.';
    
    alert(errorMessage);
  }
}